<template>
  <form @submit.prevent="submit">
    <v-row>
      <v-col cols="6">
        <DateSelector
          label="Datum od"
          ref="startDate"
          :date="form.startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="6">
        <DateSelector
          label="Datum do"
          ref="endDate"
          :date="form.endDate"
          @change="updateEndDate"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 pt-0">
        <v-btn type="submit" color="#0F998E" dark class="float-right ml-4">Prikaži</v-btn>
        <v-btn type="submit" color="#0F998E" dark class="float-right" @click="print">Tiskaj</v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import DateSelector from './DateSelector'

export default {
  components: {
    DateSelector
  },
  data () {
    return {
      form: {
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    submit () {
      this.$emit('submit', this.form)
    },
    print () {
      this.$emit('print', this.form)
    },
    clearForm () {
      this.form.startDate = moment().startOf('year').format('YYYY-MM-DD')
      this.form.endDate = moment().format('YYYY-MM-DD')
      if (this.$refs.startDate && this.$refs.endDate) {
        this.$refs.startDate.setDate(this.form.startDate)
        this.$refs.endDate.setDate(this.form.endDate)
      }
    },
    updateEndDate ({ date }) {
      this.form.endDate = date
    },
    updateStartDate ({ date }) {
      this.form.startDate = date
    }
  },
  created () {
    this.clearForm()
  }
}
</script>
